import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import {
  CircleCheckIcon,
  InfoIcon,
  TriangleAlertIcon,
  OctagonXIcon,
  Loader2Icon,
} from 'lucide-react';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          // Sonner's own base stylesheet sets background/border/color directly on
          // [data-sonner-toast] (only var(--normal-bg) etc. unless `richColors` is on), which
          // wins the cascade over a plain utility class here — the trailing `!` (Tailwind v4's
          // important syntax, see badge.tsx's `size-3!`) forces our per-type colors to apply.
          // Border intentionally matches the saturated text color (not the lighter *-border
          // tint) — same recipe as m3.html's .toast.success/.warning/.error/.info.
          toast: 'cn-toast',
          success: 'border! bg-success-bg! text-success! border-success!',
          warning: 'border! bg-warning-bg! text-warning! border-warning!',
          error: 'border! bg-danger-bg! text-danger! border-danger!',
          info: 'border! bg-info-bg! text-info! border-info!',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
